import React, { useState } from 'react';
import SearchModal from './SearchModal';

const SearchBar = () => {
  const [showSearchModal, setShowSearchModal] = useState(false);

  return (
    <>
      <div className="relative w-full max-w-xl mx-auto mb-6">
        <button
          onClick={() => setShowSearchModal(true)}
          className="w-full flex items-center space-x-2 p-3 border rounded-lg shadow-sm transition-colors text-left font-lato"
          style={{ 
            backgroundColor: 'var(--color-card-bg)', 
            borderColor: 'var(--color-input-border)',
            color: 'var(--color-charcoal)',
            opacity: 0.6
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
          <span>Search the Quran...</span>
        </button>
      </div>

      <SearchModal 
        isOpen={showSearchModal} 
        onClose={() => setShowSearchModal(false)} 
      />
    </>
  );
};

export default SearchBar;